import { truncate } from 'fs';
import { getExpiryOfToken, getIsAccessAllowed, getLocalAccessToken, getUser } from './localStorage';
// import jwt from 'jsonwebtoken'; 

export const isAuthenticated = (): boolean => {
  if (getLocalAccessToken() && getIsAccessAllowed() === "true") {
    return true;
  }
  return false;//true;//
};

export const isUserAdmin = (): boolean => {
  const currentUser = JSON.parse(getUser() || '{}');
  if (currentUser?.user_role?.toLowerCase() === "admin") {
    return true;
  }
  return false;//true;//
};


export const isExpired = (): boolean => {
  const expiresAt = new Date().getTime() + Number(getExpiryOfToken()) * 1000
  const now = new Date().getTime();
  const expiryDate = expiresAt ? expiresAt : now;
  return now < expiryDate ? false : true;
};

export const isTokenExpired = () => {
  const expirationDate : any = localStorage.getItem('expirationDate')
  const expirationDateObj = new Date(expirationDate)
  if (expirationDateObj <= new Date()) {
    return false //true
    // Token is expired
    // Perform necessary actions (e.g., logout user)
  } else {
    return true
    // Token is not expired
    // Perform necessary actions (e.g., allow user to access protected routes)
  }
};
